window.handle = require("handlebars/dist/handlebars.js");

handle.registerHelper('stripHtml', function(label){

    label = handle.escapeExpression(label);
    if(label.indexOf("-->", 3) != -1){

        var comment_position = parseInt(label.indexOf("-->", 3));
        return new handle.SafeString(label.substr(comment_position + 3));

    } else {

        return new handle.SafeString(label)

    }

});

(function($){
    "use strict";

    let linkoutUrl;

    let loadDomTemplate = '<div class="ldTemplate-wrapper"><div class="mydegree-ellipsis"><div></div><div></div><div></div><div></div></div><div><h2 class="processing-text"></h2></div><div class="mydegree-ellipsis"><div></div><div></div><div></div><div></div></div></div>';
    let processingText1 = "Searching For Qualified Programs.";


    $(document).ready(function(){
        // set the query string
        if(window.location.href.indexOf("?") == -1){
            let queryString = "";
        } else  {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            let queryStringString = urlParams.toString();
            appendCakeValues(queryStringString);
        }
    })
   


    $("form").on("submit", function(){
        // ajax search
        formValidator($(this));
    })

    let formValidator = () => {

        if($("input[name='first_name']").val() == ""){ $(".err-msg").html("Please enter a valid first name"); return false;}
        if($("input[name='last_name']").val() == ""){ $(".err-msg").html("Please enter a valid last name"); return false;}
        if($("input[name='email']").val() == ""){ $(".err-msg").html("Please enter a valid email "); return false;}
        if($("input[name='street']").val() == ""){ $(".err-msg").html("Please enter a valid address"); return false;}
        if($("input[name='phone']").val() == ""){ $(".err-msg").html("Please enter a valid phone number "); return false;}
        if($("input[name='zip']").val() == ""){ $(".err-msg").html("Please enter a valid zip code"); return false;}
        if($("input[name='city']").val() == ""){ $(".err-msg").html("Please enter a valid zip code"); return false;}
        if($("input[name='state']").val() == ""){ $(".err-msg").html("Please enter a valid zip code"); return false;}
        if($("input[name='high_graduate_year']").val() == ""){ return false;}
        if($("input[name='education_level']").val() == ""){ return false;}
        if($("input[name='enroll_plan']").val() == ""){ return false;}
        if($("input[name='us_military']").val() == ""){  return false;}

        searchSouthU(this);
    }

    let searchSouthU = () => {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if(urlParams.get('ckmsc') && urlParams.get('ckmc') && !urlParams.get('reqid')){
            $('#reqid').val(getCookie('ckmsid'));
        }

        linkoutUrl = buildLinkout();
        let data = $("form").serialize();

        console.log(data);

        return $.ajax({
            type: "post",
            url: "ajax/south-search.php",
            data: data,
            dataType: "json",
            accepts: "json",
            beforeSend: function(){
                $(".innerpage").css({visibility: "hidden"});
                $('#processModal').modal({backdrop: 'static', keyboard: false, show:true});
                $(".modal-body.loading-results").html(loadDomTemplate);
                $(".ldTemplate-wrapper .processing-text").html(processingText1);
            },
            success: function(data){
                $('#processModal').modal('hide');
                displayResults(data);
            },
            falure: function(data){

            }
        })   
    }

    let displayResults = results => {
        if(results.searchResults !== "no results found"){

            let match = {
                school_match: results.matched_schools[0],
                first_name: results.first_name,
                mdkey: results.mdkey,
                emailid: results.emailid,
            }

            $.get("match.html", (function(data){
                $(".innerpage").css({display: "none"});
                $("#banner-img").css({display: "none"});
                $("#south_match").css({display: "block"});
                let template = handle.compile(data);
                $("#match").empty().html(template(match)).fadeIn();
            }))
        } else {
            // window.location.href = linkoutUrl;
        }
    }

    $("#match").on("click", ".continue-submit-lead-button", function(e){
        e.preventDefault();
        $(this).prop('disabled', true);
        submitLead($(this));
    });

    let submitLead = (ele) => {

        $("#school_match").find("#tcpa_area_box").hide();
        var _this = ele;
        var form_response = ele.closest("form");
        var dateType = $(".card10 .date-lead").map(function(){
            return this.value;
        }).get().join('-');
       
        $("#qsToken").val(window.location.href);
        $("#dateLeadFormatted").val(dateType);
        $(".custom-error-message").hide();
        $(".custom-question").find(".error.small").hide();

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        var affiliate_id = urlParams.get('affid')

        if(affiliate_id == '30929'){
            ele.closest("form").append('<input type="hidden" name="fbc" value="'+parent.getCookie('_fbc')+'" />');
        }

        $.ajax({
            type:"post",
            url:"ajax/lead-submit.php",
            data:form_response.serialize(),
            dataType:"json",
            accept:"json",
            beforeSend: function() {
                _this.find("span").html('<strong> Submitting...</strong>');
            },
            success:function(data){
            
                fireCustomPixel(affiliate_id,data);
                window.location.href = linkoutUrl;
                //linkout to somewhere
            },
            error:function(data){
                $("#match").find("#tcpa_area_box").show();
                _this.prop('disabled', false);
                window.location.href = linkoutUrl;
                //linkout to somewhere
            }
        });
    }

    let fireCustomPixel = (affiliate_id, data) => {
        if(affiliate_id == 30929){
            fbq('init', '1455852961548446');
            fbq('track', 'Lead');
            fbq('track', 'South U Conversion', {value: data[7],currency: 'USD'});
        }
    }

    let buildLinkout = () => {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const affid = urlParams.get('affid');
        const reqid = urlParams.get('reqid');
        let url = `https://www.collegeeducationinformation.com/application.php?publisher_id=151&sub_publisher_id=${affid}&sub_publisher_id2=${reqid}`

        let subIds = ['s1', 's2', 's3', 's4', 's5'];

        subIds.forEach(subId => {
            if(urlParams.get(subId) != null){
                let id = urlParams.get(subId);
                url += `:${id}`
            }
        })


        url += `:MDL&subject=14`;

        return url; 
    }


    $(document.body).on("click", ".skip-this", function(){
      
        window.location.href = linkoutUrl;
    })

     
    $("#zip").on("keyup", function(){
        if($(this).val().length == 5){
            let zipCode = $(this).val();
            zipValidator(zipCode);
        }
    })

    let zipValidator = (zipCode) => {
        zipCode.length >= 3 && zipCode.length <= 5 ? ajaxGet("ajax/zipValidator.php?zip=" + zipCode).then((function (t) {
            if ("success" === t.data.status) {
                var e = t.data;
                localStorage.setItem('zip', zipCode);
                localStorage.setItem('city',e.data.city);
                $("#zip").css({border: "1px solid #ced4da" });
                $("#city").css({border: "1px solid #ced4da" });
                $("#state").css({border: "1px solid #ced4da" });
                $(".error").html("");
                $(".getCity, .getState").empty(),  $(".getCity").html(e.data.city + ","), $(".getState").html(e.data.state), $("input[name='city']").val(e.data.city), $("input[name='state']").val(e.data.state), $("#zipError").removeClass('invalid'),$("#zipError").html("");
            } else if ("error" === t.data.status) {
                var r = t.data.error_msg;
                $(".getCity, .getState").empty();
                var s = "<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n<i class='fa fa-exclamation-triangle'></i>\n".concat(r, "\n</span>");
                $("#zipError").html(s), $("#zipError").addClass('invalid');
            }
        })) : ($(".getCity, .getState").empty(), $("#zipError").html("<span style='padding:5px; border:1px solid #ff0000; background-color:#ffffff; color:#ff0000; margin-top:3px; display:inline-block;'>\n <i class='fa fa-exclamation-triangle'></i>\n Please check your USA zip code again.\n </span>"), $("#zipError").addClass('invalid'));
    }

    let ajaxGet = (url) => {
        return new Promise(function(resolve, reject){
            $.ajax({
                type:"GET",
                url: url,
            }).done(function(data, status){
                resolve({data, status});
            }).fail(function(data, status){
                reject({data,status});
            });
        });
    };

    let getCookie = cname => {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let appendCakeValues = t => {
        var e = -1 !== t.indexOf("affid=") ? t.substring(t.lastIndexOf("affid=") + 6) : "",
        r = -1 !== e.indexOf("&") ? e.substring(0, e.indexOf("&")) : e;
        $("#affid").val(r);
        var s = -1 !== t.indexOf("s1=") ? t.substring(t.lastIndexOf("s1=") + 3) : "",
            n = -1 !== s.indexOf("&") ? s.substring(0, s.indexOf("&")) : s;
        $("#s1").val(n);
        var i = -1 !== t.indexOf("s2=") ? t.substring(t.lastIndexOf("s2=") + 3) : "",
            a = -1 !== i.indexOf("&") ? i.substring(0, i.indexOf("&")) : i;
        $("#s2").val(a);
        var o = -1 !== t.indexOf("s3=") ? t.substring(t.lastIndexOf("s3=") + 3) : "",
            c = -1 !== o.indexOf("&") ? o.substring(0, o.indexOf("&")) : o;
        $("#s3").val(c)
    }

})(jQuery)